import moment from "moment";

export const isTherapyExpiringToday = (willBeReadyTo: string): boolean => {
  if (!willBeReadyTo) return false;

  const today = moment().startOf("day");
  const expiryDate = moment(willBeReadyTo).startOf("day");

  const diffDays = expiryDate.diff(today, "days");

  // Check if expiring exactly today (0 days)
  return diffDays === 0;
};

export const isTherapyExpiringSoon = (willBeReadyTo: string): boolean => {
  if (!willBeReadyTo) return false;

  const today = moment().startOf("day");
  const expiryDate = moment(willBeReadyTo).startOf("day");

  const diffDays = expiryDate.diff(today, "days");

  // Check if expiring in 0-3 days (inclusive)
  return diffDays >= 0 && diffDays <= 3;
};

/** @deprecated Use isTherapyExpiringSoon instead */
export const isTherapyDueSoon = (willBeReadyFrom: string): boolean => {
  if (!willBeReadyFrom) return false;

  const today = moment().startOf("day");
  const readyDate = moment(willBeReadyFrom).startOf("day");

  const diffDays = readyDate.diff(today, "days");

  // Check if diff is between 0 and 3 days (inclusive)
  return diffDays >= 0 && diffDays <= 3;
};

export const formatDate = (
  dateString: string,
  format: string = "DD.MM.YYYY"
): string => {
  if (!dateString) return "N/A";
  return moment(dateString).format(format);
};

export const isDateInRange = (
  date: string,
  startDate: string,
  endDate: string
): boolean => {
  if (!date || !startDate || !endDate) return false;

  const target = moment(date);
  const start = moment(startDate);
  const end = moment(endDate);

  return target.isBetween(start, end, "day", "[]");
};

export const getDefaultDateRange = () => ({
  startDate: moment().format("YYYY-MM-DD"),
  endDate: moment().add(30, "days").format("YYYY-MM-DD"),
});

/**
 * Calculate central therapy date (middle between willBeReadyFrom and willBeReadyTo)
 * Only for display purposes - API already provides the range
 */
export const calculateCentralTherapyDate = (
  willBeReadyFrom: string
): string => {
  return moment(willBeReadyFrom).add(7, "days").format("YYYY-MM-DD");
};

/**
 * Create tooltip using API-provided dates (no unnecessary calculations)
 */
export const createTherapyTooltip = (
  willBeReadyFrom: string,
  willBeReadyTo: string
): string => {
  const centralDate = calculateCentralTherapyDate(willBeReadyFrom);

  return (
    `Centralni datum: ${formatDate(centralDate)}\n` +
    `Poslednji dan za podizanje terapije: ${formatDate(willBeReadyTo)}`
  );
};
